



















import { i18n } from "@/plugins/i18n";

export default {
  name: "TheLanguagePicker",
  computed: {
    languages() {
      // Explained: http://2ality.com/2017/04/conditional-literal-entries.html
      return [
        ...(this.isNlEnabled ? ["nl-NL"] : []),
        ...(this.isEnEnabled ? ["en-US"] : []),
        ...(this.isFrEnabled ? ["fr-FR"] : []),
        ...(this.isDeEnabled ? ["de-DE"] : [])
      ];
    },
    isNlEnabled() {
      return this.$store.getters.getMultiSetting("Taal_ZichtbaarNederlands");
    },
    isEnEnabled() {
      return this.$store.getters.getMultiSetting("Taal_ZichtbaarEngels");
    },
    isFrEnabled() {
      return this.$store.getters.getMultiSetting("Taal_ZichtbaarFrans");
    },
    isDeEnabled() {
      return this.$store.getters.getMultiSetting("Taal_ZichtbaarDuits");
    },
    currentLanguage: {
      get() {
        return i18n.locale;
      },
      set(value) {
        i18n.locale = <string>value;
        document.title = this.$t("TheBannerLarge.title");
      }
    }
  }
};
